module.exports = __webpack_public_path__ + "images/category_lp/art_work/store_images/5_2755c0f73456518c994f19aa73758865.png";